import React, { useEffect, useState } from "react";
import { useWebData } from "../context/WebDataContext";
import { db } from "../firebaseConfig";
import { doc, updateDoc, deleteDoc, addDoc, collection } from "firebase/firestore";
import * as XLSX from "xlsx";
import Loader from "../components/Loader";

// --- 1. DATA CONSTANTS ---
// (State Data kept collapsed for clean code)
const stateDistrictData = {
    "Andhra Pradesh": ["Anantapur", "Chittoor", "East Godavari", "Guntur", "Krishna", "Kurnool", "Prakasam", "Srikakulam", "Sri Potti Sriramulu Nellore", "Visakhapatnam", "Vizianagaram", "West Godavari", "YSR District, Kadapa", "Other"],
    "Arunachal Pradesh": ["Tawang", "West Kameng", "East Kameng", "Papum Pare", "Kurung Kumey", "Kra Daadi", "Lower Subansiri", "Upper Subansiri", "West Siang", "East Siang", "Siang", "Upper Siang", "Lower Siang", "Lower Dibang Valley", "Dibang Valley", "Anjaw", "Lohit", "Namsai", "Changlang", "Tirap", "Longding", "Other"],
    "Assam": ["Baksa", "Barpeta", "Biswanath", "Bongaigaon", "Cachar", "Charaideo", "Chirang", "Darrang", "Dhemaji", "Dhubri", "Dibrugarh", "Dima Hasao", "Goalpara", "Golaghat", "Hailakandi", "Hojai", "Jorhat", "Kamrup", "Kamrup Metropolitan", "Karbi Anglong", "Karimganj", "Kokrajhar", "Lakhimpur", "Majuli", "Morigaon", "Nagaon", "Nalbari", "Sivasagar", "Sonitpur", "South Salmara-Mankachar", "Tinsukia", "Udalguri", "West Karbi Anglong", "Other"],
    "Bihar": ["Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur", "Bhojpur", "Buxar", "Darbhanga", "East Champaran", "Gaya", "Gopalganj", "Jamui", "Jehanabad", "Kaimur", "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura", "Madhubani", "Munger", "Muzaffarpur", "Nalanda", "Nawada", "Patna", "Purnia", "Rohtas", "Saharsa", "Samastipur", "Saran", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan", "Supaul", "Vaishali", "West Champaran", "Other"],
    "Chhattisgarh": ["Balod", "Baloda Bazar", "Balrampur", "Bastar", "Bemetara", "Bijapur", "Bilaspur", "Dantewada", "Dhamtari", "Durg", "Gariaband", "Janjgir-Champa", "Jashpur", "Kabirdham", "Kanker", "Kondagaon", "Korba", "Koriya", "Mahasamund", "Mungeli", "Narayanpur", "Raigarh", "Raipur", "Rajnandgaon", "Sukma", "Surajpur", "Surguja", "Other"],
    "Goa": ["North Goa", "South Goa", "Other"],
    "Gujarat": ["Ahmedabad", "Amreli", "Anand", "Aravalli", "Banaskantha", "Bharuch", "Bhavnagar", "Botad", "Chhota Udaipur", "Dahod", "Dang", "Devbhoomi Dwarka", "Gandhinagar", "Gir Somnath", "Jamnagar", "Junagadh", "Kheda", "Kutch", "Mahisagar", "Mehsana", "Morbi", "Narmada", "Navsari", "Panchmahal", "Patan", "Porbandar", "Rajkot", "Sabarkantha", "Surat", "Surendranagar", "Tapi", "Vadodara", "Valsad", "Other"],
    "Haryana": ["Ambala", "Bhiwani", "Charkhi Dadri", "Faridabad", "Fatehabad", "Gurugram", "Hisar", "Jhajjar", "Jind", "Kaithal", "Karnal", "Kurukshetra", "Mahendragarh", "Nuh", "Palwal", "Panchkula", "Panipat", "Rewari", "Rohtak", "Sirsa", "Sonipat", "Yamunanagar", "Other"],
    "Himachal Pradesh": ["Bilaspur", "Chamba", "Hamirpur", "Kangra", "Kinnaur", "Kullu", "Lahaul and Spiti", "Mandi", "Shimla", "Sirmaur", "Solan", "Una", "Other"],
    "Jharkhand": ["Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka", "East Singhbhum", "Garhwa", "Giridih", "Godda", "Gumla", "Hazaribagh", "Jamtara", "Khunti", "Koderma", "Latehar", "Lohardaga", "Pakur", "Palamu", "Ramgarh", "Ranchi", "Sahibganj", "Seraikela Kharsawan", "Simdega", "West Singhbhum", "Other"],
    "Karnataka": ["Bagalkot", "Ballari", "Belagavi", "Bengaluru Rural", "Bengaluru Urban", "Bidar", "Chamarajanagar", "Chikkaballapur", "Chikkamagaluru", "Chitradurga", "Dakshina Kannada", "Davangere", "Dharwad", "Gadag", "Hassan", "Haveri", "Kalaburagi", "Kodagu", "Kolar", "Koppal", "Mandya", "Mysuru", "Raichur", "Ramanagara", "Shivamogga", "Tumakuru", "Udupi", "Uttara Kannada", "Vijayapura", "Yadgir", "Other"],
    "Kerala": ["Alappuzha", "Ernakulam", "Idukki", "Kannur", "Kasaragod", "Kollam", "Kottayam", "Kozhikode", "Malappuram", "Palakkad", "Pathanamthitta", "Thiruvananthapuram", "Thrissur", "Wayanad", "Other"],
    "Madhya Pradesh": ["Agar Malwa", "Alirajpur", "Anuppur", "Ashoknagar", "Balaghat", "Barwani", "Betul", "Bhind", "Bhopal", "Burhanpur", "Chhatarpur", "Chhindwara", "Damoh", "Datia", "Dewas", "Dhar", "Dindori", "Guna", "Gwalior", "Harda", "Hoshangabad", "Indore", "Jabalpur", "Jhabua", "Katni", "Khandwa", "Khargone", "Mandla", "Mandsaur", "Morena", "Narsinghpur", "Neemuch", "Panna", "Raisen", "Rajgarh", "Ratlam", "Rewa", "Sagar", "Satna", "Sehore", "Seoni", "Shahdol", "Shajapur", "Sheopur", "Shivpuri", "Sidhi", "Singrauli", "Tikamgarh", "Ujjain", "Umaria", "Vidisha", "Other"],
    "Maharashtra": ["Ahmednagar", "Akola", "Amravati", "Aurangabad", "Beed", "Bhandara", "Buldhana", "Chandrapur", "Dhule", "Gadchiroli", "Gondia", "Hingoli", "Jalgaon", "Jalna", "Kolhapur", "Latur", "Mumbai City", "Mumbai Suburban", "Nagpur", "Nanded", "Nandurbar", "Nashik", "Osmanabad", "Palghar", "Parbhani", "Pune", "Raigad", "Ratnagiri", "Sangli", "Satara", "Sindhudurg", "Solapur", "Thane", "Wardha", "Washim", "Yavatmal", "Other"],
    "Manipur": ["Bishnupur", "Chandel", "Churachandpur", "Imphal East", "Imphal West", "Jiribam", "Kakching", "Kamjong", "Kangpokpi", "Noney", "Pherzawl", "Senapati", "Tamenglong", "Tengnoupal", "Thoubal", "Ukhrul", "Other"],
    "Meghalaya": ["East Garo Hills", "East Jaintia Hills", "East Khasi Hills", "North Garo Hills", "Ri Bhoi", "South Garo Hills", "South West Garo Hills", "South West Khasi Hills", "West Garo Hills", "West Jaintia Hills", "West Khasi Hills", "Other"],
    "Mizoram": ["Aizawl", "Champhai", "Kolasib", "Lawngtlai", "Lunglei", "Mamit", "Saiha", "Serchhip", "Other"],
    "Nagaland": ["Dimapur", "Kiphire", "Kohima", "Longleng", "Mokokchung", "Mon", "Peren", "Phek", "Tuensang", "Wokha", "Zunheboto", "Other"],
    "Odisha": ["Angul", "Balangir", "Balasore", "Bargarh", "Bhadrak", "Boudh", "Cuttack", "Deogarh", "Dhenkanal", "Gajapati", "Ganjam", "Jagatsinghpur", "Jajpur", "Jharsuguda", "Kalahandi", "Kandhamal", "Kendrapara", "Kendujhar", "Khordha", "Koraput", "Malkangiri", "Mayurbhanj", "Nabarangpur", "Nayagarh", "Nuapada", "Puri", "Rayagada", "Sambalpur", "Subarnapur", "Sundargarh", "Other"],
    "Punjab": ["Amritsar", "Barnala", "Bathinda", "Faridkot", "Fatehgarh Sahib", "Fazilka", "Ferozepur", "Gurdaspur", "Hoshiarpur", "Jalandhar", "Kapurthala", "Ludhiana", "Mansa", "Moga", "Muktsar", "Nawanshahr", "Pathankot", "Patiala", "Rupnagar", "Sahibzada Ajit Singh Nagar", "Sangrur", "Tarn Taran", "Other"],
    "Rajasthan": ["Ajmer", "Alwar", "Banswara", "Baran", "Barmer", "Bharatpur", "Bhilwara", "Bikaner", "Bundi", "Chittorgarh", "Churu", "Dausa", "Dholpur", "Dungarpur", "Hanumangarh", "Jaipur", "Jaisalmer", "Jalore", "Jhalawar", "Jhunjhunu", "Jodhpur", "Karauli", "Kota", "Nagaur", "Pali", "Pratapgarh", "Rajsamand", "Sawai Madhopur", "Sikar", "Sirohi", "Sri Ganganagar", "Tonk", "Udaipur", "Other"],
    "Sikkim": ["East Sikkim", "North Sikkim", "South Sikkim", "West Sikkim", "Other"],
    "Tamil Nadu": ["Ariyalur", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri", "Dindigul", "Erode", "Kanchipuram", "Kanyakumari", "Karur", "Krishnagiri", "Madurai", "Nagapattinam", "Namakkal", "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Salem", "Sivaganga", "Thanjavur", "Theni", "Thoothukudi", "Tiruchirappalli", "Tirunelveli", "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar", "Other"],
    "Telangana": ["Adilabad", "Bhadradri Kothagudem", "Hyderabad", "Jagtial", "Jangaon", "Jayashankar Bhupalpally", "Jogulamba Gadwal", "Kamareddy", "Karimnagar", "Khammam", "Komaram Bheem", "Mahabubabad", "Mahabubnagar", "Mancherial", "Medak", "Medchal", "Nagarkurnool", "Nalgonda", "Nirmal", "Nizamabad", "Peddapalli", "Rajanna Sircilla", "Rangareddy", "Sangareddy", "Siddipet", "Suryapet", "Vikarabad", "Wanaparthy", "Warangal (Rural)", "Warangal (Urban)", "Yadadri Bhuvanagiri", "Other"],
    "Tripura": ["Dhalai", "Gomati", "Khowai", "North Tripura", "Sepahijala", "South Tripura", "Unakoti", "West Tripura", "Other"],
    "Uttar Pradesh": ["Agra", "Aligarh", "Allahabad", "Ambedkar Nagar", "Amethi", "Amroha", "Auraiya", "Azamgarh", "Baghpat", "Bahraich", "Ballia", "Balrampur", "Banda", "Barabanki", "Bareilly", "Basti", "Bhadohi", "Bijnor", "Budaun", "Bulandshahr", "Chandauli", "Chitrakoot", "Deoria", "Etah", "Etawah", "Faizabad", "Farrukhabad", "Fatehpur", "Firozabad", "Gautam Buddha Nagar", "Ghaziabad", "Ghazipur", "Gonda", "Gorakhpur", "Hamirpur", "Hapur", "Hardoi", "Hathras", "Jalaun", "Jaunpur", "Jhansi", "Kannauj", "Kanpur Dehat", "Kanpur Nagar", "Kasganj", "Kaushambi", "Kheri", "Kushinagar", "Lalitpur", "Lucknow", "Maharajganj", "Mahoba", "Mainpuri", "Mathura", "Mau", "Meerut", "Mirzapur", "Moradabad", "Muzaffarnagar", "Pilibhit", "Pratapgarh", "Raebareli", "Rampur", "Saharanpur", "Sambhal", "Sant Kabir Nagar", "Shahjahanpur", "Shamli", "Shravasti", "Siddharthnagar", "Sitapur", "Sonbhadra", "Sultanpur", "Unnao", "Varanasi", "Other"],
    "Uttarakhand": ["Almora", "Bageshwar", "Chamoli", "Champawat", "Dehradun", "Haridwar", "Nainital", "Pauri Garhwal", "Pithoragarh", "Rudraprayag", "Tehri Garhwal", "Udham Singh Nagar", "Uttarkashi", "Other"],
    "West Bengal": ["Alipurduar", "Bankura", "Birbhum", "Cooch Behar", "Dakshin Dinajpur", "Darjeeling", "Hooghly", "Howrah", "Jalpaiguri", "Jhargram", "Kalimpong", "Kolkata", "Malda", "Murshidabad", "Nadia", "North 24 Parganas", "Paschim Bardhaman", "Paschim Medinipur", "Purba Bardhaman", "Purba Medinipur", "Purulia", "South 24 Parganas", "Uttar Dinajpur", "Other"],
    "Andaman and Nicobar": ["Nicobar", "North and Middle Andaman", "South Andaman", "Other"],
    "Chandigarh": ["Chandigarh", "Other"],
    "Dadra and Nagar Haveli": ["Dadra and Nagar Haveli", "Other"],
    "Daman and Diu": ["Daman", "Diu", "Other"],
    "Delhi": ["Central Delhi", "East Delhi", "New Delhi", "North Delhi", "North East Delhi", "North West Delhi", "Shahdara", "South Delhi", "South East Delhi", "South West Delhi", "West Delhi", "Other"],
    "Jammu and Kashmir": ["Anantnag", "Bandipora", "Baramulla", "Budgam", "Doda", "Ganderbal", "Jammu", "Kathua", "Kishtwar", "Kulgam", "Kupwara", "Poonch", "Pulwama", "Rajouri", "Ramban", "Reasi", "Samba", "Shopian", "Srinagar", "Udhampur", "Other"],
    "Ladakh": ["Kargil", "Leh", "Other"],
    "Lakshadweep": ["Lakshadweep", "Other"],
    "Puducherry": ["Karaikal", "Mahe", "Puducherry", "Yanam", "Other"],
    "Other": ["Other"]
};

const customerGroupOptions = ["Conference/Exhibition", "Dealer", "Free Lancer/Reseller", "Govt Hospital", "Govt Medical College", "Military Hospital", "Railway Hospital", "Private Corporate Hospital", "Private Hospital", "Private Medical College", "Private Non Profit Hospital", "Others"];
const bedsOptions = ["0-50", "50-100", "100-200", "Above 200"];
const salutationOptions = ["Dr.", "Mr.", "Mrs.", "Ms.", "Prof."];
const designationOptions = ["Secretary", "Associate", "Business Development Manager", "Project Manager", "Head of Marketing and Sales", "Executive-Sales", "Sales & Service Engineer", "Executive-Accounts/Taxation", "Supervisor-Production", "BME", "Business Development Officer", "Application Engineer", "Administrative Officer"];
const territoryOptions = ["North", "South", "East", "West", "Central"];

function Organizations() {
  const { organizations, loading } = useWebData();

  const [filtered, setFiltered] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  
  // States
  const [viewData, setViewData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  // Form State
  const [formData, setFormData] = useState({
      orgName: "", type: "Select", beds: "Select",
      salutation: "Select", firstName: "", lastName: "",
      address1: "", address2: "", city: "", 
      state: "Select", district: "Select", pincode: "", country: "India",
      mobile: "", email: "", designation: "Select", territory: "Select"
  });

  const [districtList, setDistrictList] = useState([]);

  // ==========================================
  // 🔥🔥 HELPERS: CLICK TO CALL / EMAIL 🔥🔥
  // ==========================================
  const handleWhatsApp = (mobile) => {
      if(!mobile) return;
      // Remove spaces, dashes, parentheses
      let number = mobile.toString().replace(/\D/g, '');
      // If 10 digits (e.g. 9876543210), append 91.
      if(number.length === 10) number = "91" + number;
      window.open(`https://wa.me/${number}`, '_blank');
  };

  const handleEmail = (email) => {
      if(email) window.location.href = `mailto:${email}`;
  };

  // ==========================================
  // 1. SUPER SEARCH & FILTER
  // ==========================================
  useEffect(() => {
    let result = organizations || [];
    // Sort Alphabetically
    result = [...result].sort((a, b) => (a.name || "").localeCompare(b.name || ""));

    if (searchTerm) {
        const keywords = searchTerm.toLowerCase().split(" ").filter(w => w);
        result = result.filter(i => {
            const dateStr = formatDate(i.createdAt).toLowerCase();
            const row = `
                ${dateStr} ${i.name} ${i.type} ${i.beds} 
                ${i.contactPerson} ${i.mobile} ${i.email} ${i.designation} 
                ${i.city} ${i.district} ${i.state} ${i.territory} ${i.pincode}
            `.toLowerCase();
            return keywords.every(w => row.includes(w));
        });
    }
    setFiltered(result);
  }, [organizations, searchTerm]);

  // 2. HANDLE STATE CHANGE
  useEffect(() => {
      if (formData.state && stateDistrictData[formData.state]) {
          setDistrictList(stateDistrictData[formData.state]);
      } else {
          setDistrictList([]);
      }
  }, [formData.state]);

  // 3. ADD / UPDATE
  const handleSave = async () => {
      if (!formData.orgName || formData.type === 'Select' || formData.state === 'Select') {
          return alert("Missing Fields: Name, Type and State are required.");
      }

      const payload = {
          name: formData.orgName,
          type: formData.type,
          beds: formData.beds,
          salutation: formData.salutation,
          firstName: formData.firstName,
          lastName: formData.lastName,
          contactPerson: `${formData.salutation} ${formData.firstName} ${formData.lastName}`.trim(),
          address1: formData.address1,
          address2: formData.address2,
          city: formData.city,
          state: formData.state,
          district: formData.district,
          pincode: formData.pincode,
          country: formData.country,
          mobile: formData.mobile,
          email: formData.email,
          designation: formData.designation,
          territory: formData.territory,
          address: `${formData.address1}, ${formData.address2}, ${formData.city}`,
          equipment: { ventilator: 0, monitor: 0, anesthesia: 0, compressor: 0, bubble: 0 }
      };

      try {
          if (isEditMode && editId) {
              await updateDoc(doc(db, "organizations", editId), payload);
              alert("Updated Successfully ✅");
          } else {
              await addDoc(collection(db, "organizations"), {
                  ...payload,
                  createdAt: new Date().toISOString()
              });
              alert("Added Successfully ✅");
          }
          closeModal();
      } catch (e) { alert("Error saving: " + e.message); }
  };

  const openAdd = () => {
      setIsEditMode(false);
      setFormData({
          orgName: "", type: "Select", beds: "Select", salutation: "Select",
          firstName: "", lastName: "", address1: "", address2: "", city: "",
          state: "Select", district: "Select", pincode: "", country: "India",
          mobile: "", email: "", designation: "Select", territory: "Select"
      });
      setShowModal(true);
  };

  const openEdit = (org) => {
      setIsEditMode(true);
      setEditId(org.id);
      setFormData({
          orgName: org.name || "",
          type: org.type || "Select",
          beds: org.beds || "Select",
          salutation: org.salutation || "Select",
          firstName: org.firstName || "",
          lastName: org.lastName || "",
          address1: org.address1 || "",
          address2: org.address2 || "",
          city: org.city || "",
          state: org.state || "Select",
          district: org.district || "Select",
          pincode: org.pincode || "",
          country: org.country || "India",
          mobile: org.mobile || "",
          email: org.email || "",
          designation: org.designation || "Select",
          territory: org.territory || "Select"
      });
      setShowModal(true);
  };

  const closeModal = () => {
      setShowModal(false);
      setEditId(null);
  };

  const handleDelete = async (id) => {
      if(window.confirm("Delete this organization?")) await deleteDoc(doc(db, "organizations", id));
  };

  // 4. EXCEL DOWNLOAD
  const downloadExcel = () => {
    const dataToExport = filtered.map(o => ({
        Created_Date: formatDate(o.createdAt),
        Org_Name: o.name,
        Type: o.type,
        Beds: o.beds,
        Contact_Person: o.contactPerson,
        Designation: o.designation,
        Mobile: o.mobile,
        Email: o.email,
        Address_Line_1: o.address1,
        Address_Line_2: o.address2,
        City: o.city,
        District: o.district,
        State: o.state,
        Pincode: o.pincode,
        Country: o.country,
        Territory: o.territory
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Organizations");
    XLSX.writeFile(wb, "Organizations_Master_List.xlsx");
  };

  const formatDate = (iso) => {
      if(!iso) return "-";
      const date = new Date(iso);
      return isNaN(date.getTime()) ? iso : date.toLocaleDateString('en-GB');
  };

  return (
    <div style={{padding:"20px", fontFamily:"'Segoe UI', sans-serif", backgroundColor:"#f8f9fa", minHeight:"100vh"}}>
      
      {/* HEADER */}
      <div style={headerCard}>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"15px"}}>
            <h2 style={{margin:0, color:"#2c3e50", display:"flex", alignItems:"center"}}>
                🏥 Organizations <span style={{fontSize:"14px", color:"#777", marginLeft:"10px"}}>({filtered.length})</span>
            </h2>
            <div style={{display:"flex", gap:"10px"}}>
                <button onClick={openAdd} style={btnAdd}>➕ Add New</button>
                <button onClick={downloadExcel} style={btnDownload}>📥 Download All</button>
            </div>
        </div>

        {/* SEARCH BAR */}
        <div style={{display:"flex", justifyContent:"flex-start"}}>
            <input type="text" placeholder="🔍 Search Name, City, Contact, Date..." value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)} style={searchInput} />
        </div>
      </div>

      {loading ? <Loader /> : (
        <div style={{overflowX:"auto", backgroundColor:"white", borderRadius:"8px", boxShadow:"0 2px 10px rgba(0,0,0,0.05)"}}>
          <table style={tableStyle}>
            <thead>
                <tr style={{backgroundColor:"#2c3e50", color:"white", textAlign:"left"}}>
                    <th style={thStyle}>Date</th>
                    <th style={thStyle}>Organization</th>
                    <th style={thStyle}>Location</th>
                    <th style={thStyle}>Contact</th>
                    <th style={thStyle}>Actions</th>
                </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                  <tr><td colSpan="5" style={{padding:"20px", textAlign:"center", color:"#999"}}>No organizations found.</td></tr>
              ) : filtered.map(o => (
                <tr key={o.id} style={{borderBottom:"1px solid #eee", height:"45px"}}>
                    <td style={tdStyle}>{formatDate(o.createdAt)}</td>
                    
                    <td style={{...tdStyle, textAlign:"left"}}>
                        <div style={{fontWeight:"bold", color:"#2c3e50"}}>{o.name}</div>
                        <div style={{fontSize:"11px", color:"#7f8c8d"}}>{o.type} ({o.beds} Beds)</div>
                    </td>
                    
                    <td style={{...tdStyle, textAlign:"left"}}>
                        <div style={{fontWeight:"bold"}}>{o.city}</div>
                        <div style={{fontSize:"11px", color:"#555"}}>{o.district}, {o.state}</div>
                    </td>
                    
                    {/* 🔥🔥 UPDATED CONTACT COLUMN 🔥🔥 */}
                    <td style={{...tdStyle, textAlign:"left"}}>
                        <div style={{fontWeight:"bold"}}>{o.contactPerson}</div>
                        
                        {/* 1. Clickable Mobile */}
                        {o.mobile && (
                            <div 
                                onClick={()=>handleWhatsApp(o.mobile)} 
                                style={{fontSize:"11px", color:"green", cursor:"pointer", display:"flex", alignItems:"center", gap:"3px", marginTop:"2px"}}
                                title="Chat on WhatsApp"
                            >
                                📱 {o.mobile}
                            </div>
                        )}

                        {/* 2. Clickable Email */}
                        {o.email && (
                            <div 
                                onClick={()=>handleEmail(o.email)} 
                                style={{fontSize:"11px", color:"blue", cursor:"pointer", display:"flex", alignItems:"center", gap:"3px", marginTop:"2px"}}
                                title="Send Email"
                            >
                                📧 {o.email}
                            </div>
                        )}
                    </td>
                    
                    <td style={tdStyle}>
                        <div style={{display:"flex", gap:"5px", justifyContent:"center"}}>
                            <button onClick={() => setViewData(o)} style={btnIcon} title="View All Details">👁️</button>
                            <button onClick={() => openEdit(o)} style={btnIconEdit} title="Edit">✏️</button>
                            <button onClick={() => handleDelete(o.id)} style={btnIconDelete} title="Delete">🗑️</button>
                        </div>
                    </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* VIEW MODAL */}
      {viewData && (
        <div style={modalOverlay}>
          <div style={modalContent}>
            <h3 style={{color:"#2c3e50", marginTop:0, borderBottom:"1px solid #eee", paddingBottom:"10px"}}>{viewData.name}</h3>
            <div style={{fontSize:"13px", lineHeight:"1.6"}}>
                <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:"15px"}}>
                    <div>
                        <h4 style={{margin:"0 0 5px 0", color:"#e67e22"}}>🏢 Basic Info</h4>
                        <p style={{margin:0}}><strong>Type:</strong> {viewData.type}</p>
                        <p style={{margin:0}}><strong>Beds:</strong> {viewData.beds}</p>
                        <p style={{margin:0}}><strong>Date Added:</strong> {formatDate(viewData.createdAt)}</p>
                    </div>
                    <div>
                        <h4 style={{margin:"0 0 5px 0", color:"#27ae60"}}>📍 Location</h4>
                        <p style={{margin:0}}>{viewData.address1}</p>
                        <p style={{margin:0}}>{viewData.address2}</p>
                        <p style={{margin:0}}><strong>City:</strong> {viewData.city} - {viewData.pincode}</p>
                        <p style={{margin:0}}><strong>State:</strong> {viewData.state} ({viewData.district})</p>
                        <p style={{margin:0}}><strong>Territory:</strong> {viewData.territory}</p>
                    </div>
                </div>
                <hr style={{border:"0.5px solid #eee", margin:"15px 0"}}/>
                <div>
                    <h4 style={{margin:"0 0 5px 0", color:"#2980b9"}}>👤 Contact Person</h4>
                    <p style={{margin:0}}><strong>Name:</strong> {viewData.contactPerson}</p>
                    <p style={{margin:0}}><strong>Designation:</strong> {viewData.designation}</p>
                    
                    <p style={{margin:"5px 0", cursor:"pointer", color:"green", fontWeight:"bold"}} onClick={()=>handleWhatsApp(viewData.mobile)}>
                        📱 Mobile: {viewData.mobile} (Click to Chat)
                    </p>
                    
                    <p style={{margin:0, cursor:"pointer", color:"blue", fontWeight:"bold"}} onClick={()=>handleEmail(viewData.email)}>
                        📧 Email: {viewData.email}
                    </p>
                </div>
            </div>
            <button onClick={() => setViewData(null)} style={btnClose}>Close</button>
          </div>
        </div>
      )}

      {/* ADD / EDIT MODAL */}
      {showModal && (
        <div style={modalOverlay}>
          <div style={{...modalContent, width:"700px", maxHeight:"90vh", overflowY:"auto"}}>
            <h3 style={{color:"#f39c12", marginTop:0, borderBottom:"1px solid #eee", paddingBottom:"10px"}}>
                {isEditMode ? "✏️ Edit Organization" : "➕ New Organization"}
            </h3>
            
            <div style={gridContainer}>
                <div style={sectionBox}>
                    <h4 style={sectionTitle}>🏢 Basic Details</h4>
                    <label style={labelStyle}>Organization Name *</label>
                    <input type="text" value={formData.orgName} onChange={(e)=>setFormData({...formData, orgName:e.target.value})} style={modalInput}/>
                    
                    <div style={{display:"flex", gap:"10px"}}>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>Customer Group</label>
                            <select value={formData.type} onChange={(e)=>setFormData({...formData, type:e.target.value})} style={modalInput}>
                                <option>Select</option>
                                {customerGroupOptions.map(o => <option key={o}>{o}</option>)}
                            </select>
                        </div>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>Beds</label>
                            <select value={formData.beds} onChange={(e)=>setFormData({...formData, beds:e.target.value})} style={modalInput}>
                                <option>Select</option>
                                {bedsOptions.map(o => <option key={o}>{o}</option>)}
                            </select>
                        </div>
                    </div>
                </div>

                <div style={sectionBox}>
                    <h4 style={sectionTitle}>📍 Location</h4>
                    <label style={labelStyle}>Address Line 1</label>
                    <input type="text" value={formData.address1} onChange={(e)=>setFormData({...formData, address1:e.target.value})} style={modalInput}/>
                    
                    <label style={labelStyle}>Address Line 2</label>
                    <input type="text" value={formData.address2} onChange={(e)=>setFormData({...formData, address2:e.target.value})} style={modalInput}/>

                    <div style={{display:"flex", gap:"10px"}}>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>State *</label>
                            <select value={formData.state} onChange={(e)=>setFormData({...formData, state:e.target.value, district:"Select"})} style={modalInput}>
                                <option>Select</option>
                                {Object.keys(stateDistrictData).map(s => <option key={s}>{s}</option>)}
                            </select>
                        </div>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>District</label>
                            <select value={formData.district} onChange={(e)=>setFormData({...formData, district:e.target.value})} style={modalInput}>
                                <option>Select</option>
                                {districtList.map(d => <option key={d}>{d}</option>)}
                            </select>
                        </div>
                    </div>

                    <div style={{display:"flex", gap:"10px"}}>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>City/Tehsil</label>
                            <input type="text" value={formData.city} onChange={(e)=>setFormData({...formData, city:e.target.value})} style={modalInput}/>
                        </div>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>Pincode</label>
                            <input type="number" value={formData.pincode} onChange={(e)=>setFormData({...formData, pincode:e.target.value})} style={modalInput}/>
                        </div>
                    </div>
                </div>

                <div style={sectionBox}>
                    <h4 style={sectionTitle}>👤 Contact Person</h4>
                    <div style={{display:"flex", gap:"10px"}}>
                        <div style={{width:"80px"}}>
                            <label style={labelStyle}>Salutation</label>
                            <select value={formData.salutation} onChange={(e)=>setFormData({...formData, salutation:e.target.value})} style={modalInput}>
                                <option>Select</option>
                                {salutationOptions.map(s => <option key={s}>{s}</option>)}
                            </select>
                        </div>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>First Name</label>
                            <input type="text" value={formData.firstName} onChange={(e)=>setFormData({...formData, firstName:e.target.value})} style={modalInput}/>
                        </div>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>Last Name</label>
                            <input type="text" value={formData.lastName} onChange={(e)=>setFormData({...formData, lastName:e.target.value})} style={modalInput}/>
                        </div>
                    </div>

                    <div style={{display:"flex", gap:"10px"}}>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>Mobile</label>
                            <input type="text" value={formData.mobile} onChange={(e)=>setFormData({...formData, mobile:e.target.value})} style={modalInput}/>
                        </div>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>Email</label>
                            <input type="email" value={formData.email} onChange={(e)=>setFormData({...formData, email:e.target.value})} style={modalInput}/>
                        </div>
                    </div>

                    <div style={{display:"flex", gap:"10px"}}>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>Designation</label>
                            <select value={formData.designation} onChange={(e)=>setFormData({...formData, designation:e.target.value})} style={modalInput}>
                                <option>Select</option>
                                {designationOptions.map(d => <option key={d}>{d}</option>)}
                            </select>
                        </div>
                        <div style={{flex:1}}>
                            <label style={labelStyle}>Territory</label>
                            <select value={formData.territory} onChange={(e)=>setFormData({...formData, territory:e.target.value})} style={modalInput}>
                                <option>Select</option>
                                {territoryOptions.map(t => <option key={t}>{t}</option>)}
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{marginTop:"15px", textAlign:"right"}}>
                <button onClick={closeModal} style={btnCancel}>Cancel</button>
                <button onClick={handleSave} style={btnSave}>{isEditMode ? "Update" : "Save"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// STYLES
const headerCard={backgroundColor:"white", padding:"20px", borderRadius:"10px", boxShadow:"0 2px 8px rgba(0,0,0,0.05)", marginBottom:"20px"};
const tableStyle={width:"100%", borderCollapse:"collapse", fontSize:"13px"};
const thStyle={padding:"12px 15px", borderBottom:"2px solid #eee", fontSize:"12px", textTransform:"uppercase", letterSpacing:"0.5px"};
const tdStyle={padding:"10px 15px", verticalAlign:"middle"};
const searchInput={padding:"8px 12px", border:"1px solid #ddd", borderRadius:"6px", width:"300px", outline:"none"};
const btnDownload={backgroundColor:"#27ae60", color:"white", border:"none", padding:"8px 15px", borderRadius:"5px", cursor:"pointer", fontWeight:"bold", fontSize:"13px"};
const btnAdd={backgroundColor:"#e67e22", color:"white", border:"none", padding:"8px 15px", borderRadius:"5px", cursor:"pointer", fontWeight:"bold", fontSize:"13px", marginRight:"10px"};

const btnIcon={backgroundColor:"#3498db", color:"white", border:"none", padding:"5px 8px", borderRadius:"4px", cursor:"pointer", marginRight:"5px"};
const btnIconEdit={backgroundColor:"#f39c12", color:"white", border:"none", padding:"5px 8px", borderRadius:"4px", cursor:"pointer", marginRight:"5px"};
const btnIconDelete={backgroundColor:"#fff", color:"#777", border:"1px solid #ddd", padding:"5px 8px", borderRadius:"4px", cursor:"pointer"};

const modalOverlay={position:"fixed", top:0, left:0, width:"100%", height:"100%", background:"rgba(0,0,0,0.5)", display:"flex", justifyContent:"center", alignItems:"center", zIndex:1000};
const modalContent={background:"white", padding:"25px", borderRadius:"12px", width:"450px", boxShadow:"0 10px 30px rgba(0,0,0,0.2)", position:"relative"};
const modalInput={width:"100%", padding:"8px", margin:"3px 0", borderRadius:"4px", border:"1px solid #ccc", boxSizing:"border-box", fontSize:"12px"};
const labelStyle={fontSize:"11px", fontWeight:"bold", color:"#555", marginTop:"5px", display:"block"};
const btnSave={backgroundColor:"#27ae60", color:"white", border:"none", padding:"10px 20px", borderRadius:"4px", cursor:"pointer", marginLeft:"5px", fontWeight:"bold"};
const btnCancel={backgroundColor:"#95a5a6", color:"white", border:"none", padding:"10px 20px", borderRadius:"4px", cursor:"pointer"};
const btnClose={marginTop:"15px", backgroundColor:"#333", color:"white", border:"none", padding:"8px", borderRadius:"4px", width:"100%", cursor:"pointer"};
const gridContainer={display:"grid", gridTemplateColumns:"1fr", gap:"15px"};
const sectionBox={background:"#f9f9f9", padding:"15px", borderRadius:"8px", border:"1px solid #eee"};
const sectionTitle={margin:"0 0 10px 0", color:"#2980b9", borderBottom:"2px solid #ddd", paddingBottom:"5px", fontSize:"14px"};

export default Organizations;